import { NgModule, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { NgxPaginationModule } from 'ngx-pagination';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TabsModule } from 'ngx-bootstrap/tabs';

import { FVEnviroment } from '../models/enviroment';

import { ApiService } from '../services/api.service';
import { StorageService } from '../services/storage.service';
import { LanguageService } from '../services/language.service';
import { FVNotificationService } from '../services/notification.service';
import { LowerTranslatePipe } from '../pipes/translate.pipe';

import { FBRendererComponent } from '../components/renderer/form-renderer.component';

@NgModule({
  declarations: [
    FBRendererComponent,
  ],
  imports: [
    BsDatepickerModule.forRoot(),
    PaginationModule.forRoot(),
    TranslateModule.forRoot(),
    AccordionModule.forRoot(),
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    TabsModule.forRoot(),
    NgxPaginationModule,
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [
    ApiService,
    StorageService,
    LanguageService,
    FVNotificationService,
    LowerTranslatePipe,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FormBuilderModule {
  public static forRoot(enviroment: FVEnviroment): ModuleWithProviders {
    return {
      ngModule: FormBuilderModule,
      providers: [
        ApiService,
        StorageService,
        LanguageService,
        FVNotificationService,
        { provide: 'enviroment', useValue: enviroment },
      ],
    };
  }
}
